import SqzlCommon from './files/common.js';
import SqzlTransmit from './files/basetracker.js';
import SqzlPersonalization from './files/personalization/basePersonalization.js';

new SqzlCommon();

new SqzlTransmit();
sqzlCommon.g.sqzlInitQueue.push(sqzlCommon.g.sqzlTransmit.init.bind(sqzlCommon.g.sqzlTransmit));

new SqzlPersonalization();
sqzlCommon.g.sqzlInitQueue.push(sqzlCommon.g.sqzlPersonalization.init.bind(sqzlCommon.g.sqzlPersonalization));